export default "__VITE_ASSET__D7Zbc2oC__"